module.exports = __webpack_public_path__ + "static/banner_illustration-852e77432ab4cdd2bc629b55ad3ccf72.svg";